<!-- <div class="row mt-3">
    <div class="col-12 col-lg-6 col-xl-2 ">
        <div class="card" (click)="ToiletReports('all');">
            <div class="card-body text-center">
                <h3 class="text-primary"><i class="zmdi zmdi-local-wc"></i></h3>
                <h6 class="mb-0 text-dark my-2">Total Toilets</h6>
                <div *ngIf="isLoading">
                    <div class="d-flex justify-content-center ">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>
                <h2 class="text-dark totalToilet">
                    
                </h2>
                
            </div>
        </div>
    </div>

    <div class="col-12 col-lg-6 col-xl-2 ">
        <div class="card" (click)="ToiletReports('Clean');">
            <div class="card-body text-center">
                <h3 class="text-success"><i class="fa fa-thumbs-up"></i></h3>
                <h6 class="mb-0 text-dark my-2">Clean Toilets</h6>
                <div *ngIf="isLoading">
                    <div class="d-flex justify-content-center ">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>
                <h2 class="text-success totalCleanToilets">
                    
                </h2>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-2 ">
        <div class="card" (click)="ToiletReports('Ok');">
            <div class="card-body text-center">
                <h3 class="text-warning"><i class="fa fa-thumbs-up"></i></h3>
                <h6 class="mb-0 text-dark my-2">Ok Toilets</h6>
                <div *ngIf="isLoading">
                    <div class="d-flex justify-content-center ">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>
                <h2 class="text-warning totalOkToilets">
                    
                </h2>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-2 ">
        <div class="card" (click)="ToiletReports('Dirty');">
            <div class="card-body text-center">
                <h3 class="text-danger"><i class="fa fa-thumbs-down"></i></h3>
                <h6 class="mb-0 text-dark my-2">Dirty Toilets</h6>
                <div *ngIf="isLoading">
                    <div class="d-flex justify-content-center ">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>
                <h2 class="text-danger totalDirtyToilets">
                     
                </h2>
            </div>
        </div>
    </div>

    <div class="col-12 col-lg-6 col-xl-2 ">
        <div class="card">
            <div class="card-body text-center">
                <h3 class="text-secondary"><i class="fa fa-wrench" aria-hidden="true"></i></h3>
                <h6 class="mb-0 text-dark my-2">Toilet Under Repair</h6>
                <div *ngIf="isLoading">
                    <div class="d-flex justify-content-center ">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>
                <h2 class="text-secondary totalUnderRepairToilets">
                     
                </h2>
            </div>
        </div>
    </div>

    <div class="col-12 col-lg-6 col-xl-2 h-75">
        <div class="card">
            <div class="card-body text-center h-75">
            <p class="mb-0 text-dark small-font">Average Cleanliness Score</p>
            <div *ngIf="isLoading">
                <div class="d-flex justify-content-center ">
                    <div class="spinner-border" role="status"></div>
                </div>
            </div>
            
            <div 
                class="circular-progress"
                [ngStyle]="{
                background:
                    'conic-gradient(#007bff 0% ' +
                    currentPercentage +
                    '%, #e6e6e6 ' +
                    currentPercentage +
                    '% 100%)'
                }"
            >
                <div class="progress-value currentPercentage"> </div>
            </div>
            </div>
        </div>
    </div>

</div> -->

<div class="row mt-3">

    <!-- Total Toilets -->
    <div class="col-12 col-sm-6 col-lg-4 col-xl-2 d-flex mb-3">
        <div class="card dashboard-card w-100 h-100" (click)="ToiletReports('all');">
            <div class="card-body text-center d-flex flex-column justify-content-center">
                <h3 class="text-primary mb-2">
                    <i class="zmdi zmdi-local-wc"></i>
                </h3>

                <h6 class="mb-2 text-dark">Total Toilets</h6>

                <div *ngIf="isLoading" class="d-flex justify-content-center mb-2">
                    <div class="spinner-border" role="status"></div>
                </div>

                <h2 class="text-dark totalToilet mb-0"></h2>
            </div>
        </div>
    </div>

    <!-- Clean Toilets -->
    <div class="col-12 col-sm-6 col-lg-4 col-xl-2 d-flex mb-3">
        <div class="card dashboard-card w-100 h-100" (click)="ToiletReports('Clean');">
            <div class="card-body text-center d-flex flex-column justify-content-center">
                <h3 class="text-success mb-2">
                    <i class="fa fa-thumbs-up"></i>
                </h3>

                <h6 class="mb-2 text-dark">Clean Toilets</h6>

                <div *ngIf="isLoading" class="d-flex justify-content-center mb-2">
                    <div class="spinner-border" role="status"></div>
                </div>

                <h2 class="text-success totalCleanToilets mb-0"></h2>
            </div>
        </div>
    </div>

    <!-- Ok Toilets -->
    <div class="col-12 col-sm-6 col-lg-4 col-xl-2 d-flex mb-3">
        <div class="card dashboard-card w-100 h-100" (click)="ToiletReports('Ok');">
            <div class="card-body text-center d-flex flex-column justify-content-center">
                <h3 class="text-warning mb-2">
                    <i class="fa fa-thumbs-up"></i>
                </h3>

                <h6 class="mb-2 text-dark">Ok Toilets</h6>

                <div *ngIf="isLoading" class="d-flex justify-content-center mb-2">
                    <div class="spinner-border" role="status"></div>
                </div>

                <h2 class="text-warning totalOkToilets mb-0"></h2>
            </div>
        </div>
    </div>

    <!-- Dirty Toilets -->
    <div class="col-12 col-sm-6 col-lg-4 col-xl-2 d-flex mb-3">
        <div class="card dashboard-card w-100 h-100" (click)="ToiletReports('Dirty');">
            <div class="card-body text-center d-flex flex-column justify-content-center">
                <h3 class="text-danger mb-2">
                    <i class="fa fa-thumbs-down"></i>
                </h3>

                <h6 class="mb-2 text-dark">Dirty Toilets</h6>

                <div *ngIf="isLoading" class="d-flex justify-content-center mb-2">
                    <div class="spinner-border" role="status"></div>
                </div>

                <h2 class="text-danger totalDirtyToilets mb-0"></h2>
            </div>
        </div>
    </div>

    <!-- Under Repair -->
    <div class="col-12 col-sm-6 col-lg-4 col-xl-2 d-flex mb-3">
        <div class="card dashboard-card w-100 h-100">
            <div class="card-body text-center d-flex flex-column justify-content-center">
                <h3 class="text-secondary mb-2">
                    <i class="fa fa-wrench"></i>
                </h3>

                <h6 class="mb-2 text-dark">Toilet Under Repair</h6>

                <div *ngIf="isLoading" class="d-flex justify-content-center mb-2">
                    <div class="spinner-border" role="status"></div>
                </div>

                <h2 class="text-secondary totalUnderRepairToilets mb-0"></h2>
            </div>
        </div>
    </div>

    <!-- Average Cleanliness Score -->
    <div class="col-12 col-sm-6 col-lg-4 col-xl-2 d-flex mb-3">
        <div class="card dashboard-card w-100 h-100">
            <div class="card-body text-center d-flex flex-column justify-content-center">

                <p class="mb-2 text-dark small-font">
                    Average Cleanliness Score
                </p>

                <div *ngIf="isLoading" class="d-flex justify-content-center mb-2">
                    <div class="spinner-border" role="status"></div>
                </div>

                <div
                    class="circular-progress mx-auto"
                    [ngStyle]="{
                        background:
                        'conic-gradient(#007bff 0% ' +
                        currentPercentage +
                        '%, #e6e6e6 ' +
                        currentPercentage +
                        '% 100%)'
                    }">

                    <div class="progress-value currentPercentage"></div>

                </div>
            </div>
        </div>
    </div>

</div>

<!-- <div class="row mt-3">
    <div class="col-12 col-lg-6 col-xl-3">
        <div class="card " (click)="InstallDevices();">
            <div class="card-body">
                <h5 class="text-dark mb-0" *ngIf="totalDevices !== null && totalDevices !== undefined">
                    {{ totalDevices }}
                    <span class="float-right text-dark"><i class="fa fa-info-circle"></i></span>
                </h5>
                <p class="mb-0 text-dark small-font">Total Installed IoT Devices</p>
            </div>
        </div>
    </div>

    <div class="col-12 col-lg-6 col-xl-3">
        <div class="card " (click)="ActiveDevices();">
            <div class="card-body">
                <h5 class="text-dark mb-0" *ngIf="totalActiveDevices !== null && totalActiveDevices !== undefined">
                    {{totalActiveDevices}}
                    <span class="float-right text-dark"><i class="fa fa-list-ul"></i></span>
                </h5>
                <p class="mb-0 text-dark small-font">Total Active IoT Devices</p>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
        <div class="card " (click)="InactiveDevices();">
            <div class="card-body">
                <h5 class="text-dark mb-0" *ngIf="totalInactiveDevices !== null && totalInactiveDevices !== undefined">
                    {{totalInactiveDevices}}
                    <span class="float-right text-dark"><i class="fa fa-list-ul"></i></span>
                </h5>

                <p class="mb-0 text-dark small-font">Total Inactive IoT Devices</p>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
        <div class="card " (click)="ToiletReports();">
            <div class="card-body">
                <h5 class="text-dark mb-0" *ngIf="totalToilet !== null && totalToilet !== undefined">
                    {{totalToilet}}
                    <span class="float-right text-dark"><i class="fa fa-link"></i></span>
                </h5>

                <p class="mb-0 text-dark small-font">Total Toilet</p>
            </div>
        </div>
    </div>
</div> -->
<!-- Google Map -->

<div class="row mb-4">
    <div class="col-12">
        <div id="map" class="map"></div>
    </div>
</div>


<div id="popup" class="ol-popup">
    <a href="#" id="popup-closer" class="ol-popup-closer"></a>
    <div id="popup-content"></div>
</div>
<!-- <div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title"> <i class="fa fa-users  p-2" style="font-size: 20px;"></i>Toilets Needing Attention List
                </h5>
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Toilet ID</th>
                                <th>MoHUA (GTL ID)</th>
                                <th>Status</th>
                                <th>Dirty Time</th>
                                <th>Assign To</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of dirtyRowData; let i = index">
                                <td>{{i+1}}</td>
                                <td>{{data.toilet_no}}</td>
                                <td>{{data.google_toilet_id}}</td>
                                <td><span class="badge badge-success">{{data.toilet_status}}</span></td>
                                <td>{{data.dirty_start_time | date:'dd-MM-yyyy HH:mm:ss'}}</td>
                                <td>
                                    <button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#contactModal" (click)="ShowContactDetail(data)">Assign</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!--chart-->
<div class="row">
    <div class="col-lg-6">
        <div class="card">
            <div class="card-body">
                <div class="card-title"><i class="fa fa-thermometer-quarter p-2" style="font-size: 25px;"></i>
                    Air Quality
                </div>

                <!-- Loader -->
                <div *ngIf="isLoading">
                    <div class="d-flex justify-content-between ">
                        <span>Loading...</span>
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>

                <div class="row" *ngIf="!isLoading">
                    <div class="col-lg-6 ">
                        <canvas baseChart [data]="airQualityData" [labels]="airQualityLabels"
                            [options]="airQualityOptions" [chartType]="airQualityType" [colors]="airQualityColors"
                            (chartHover)="chartHovered($event)" data-toggle="modal" data-target="#devicePopupModal"
                            (chartClick)="chartClicked($event,'aqi')">
                        </canvas>
                    </div>
                    <div class="col-lg-6 px-1">
                        <div class="table-responsive pt-0">
                            <table class="table align-items-center">
                                <tbody>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #14abef"></i>Good</td>
                                        <td>{{goodAirQuality}}</td>
                                    </tr>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #02ba5a"></i>Moderate</td>
                                        <td>{{moderateAirQuality}}</td>
                                    </tr>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #d13adf"></i>Unhealthy</td>
                                        <td>{{unhealthyAirQuality}}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #fba540"></i>Very Unhealthy</td>
                                        <td>{{veryUnhealthyAirQuality}}</td>
                                    </tr>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #000"></i>Hazardous</td>
                                        <td>{{hazardousAirQuality}}</td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-6">
        <div class="card">
            <div class="card-body">
                <div class="card-title"><i class="fa fa-comment-o p-2"
                        style="font-size: 25px;"></i>
                    User Feedback
                </div>
                <!-- Loader -->
                <div *ngIf="isLoading">
                    <div class="d-flex justify-content-between ">
                        <span>Loading...</span>
                        <div class="spinner-border" role="status"></div>

                    </div>
                </div>
                <!-- <div class="row" *ngIf="!isLoading"> -->
                <div class="row" *ngIf="!isLoading">
                    <div class="col-lg-6">
                        <canvas baseChart [data]="feedbackData" [labels]="feedbackLable" [options]="feedbackOptions"
                            [chartType]="feedbackType" [colors]="feedbackColors" data-toggle="modal"
                            data-target="#devicePopupModal" (chartClick)="chartClicked($event,'feedback')">
                        </canvas>
                    </div>
                    <div class="col-lg-6">
                        <div class="table-responsive pt-1">
                            <table class="table align-items-center">
                                <tbody>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #191970"></i> Clean</td>
                                        <td>{{feedbackExcellent}}</td>
                                    </tr>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #00BFFF"></i>Ok</td>
                                        <td>{{feedbackGood}}</td>
                                    </tr>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #008080"></i>Dirty</td>
                                        <td>{{feedbackPoor}}</td>
                                    </tr>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #7CB9E8"></i>No Feedback</td>
                                        <td>{{feedbackNA}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="col-lg-4">
        <div class="card">
            <div class="card-body">
                <div class="card-title"><i class="fa fa-tint p-2" style="font-size: 25px;"></i>
                    Water Level
                </div>
                <div *ngIf="isLoading">
                    <div class="d-flex justify-content-between ">
                        <span>Loading...</span>
                        <div class="spinner-border" role="status">

                        </div>

                    </div>
                </div>
                <div class="row" *ngIf="!isLoading">
                    <div class="col-lg-6">
                        <canvas baseChart [data]="waterLevelData" [labels]="waterLevelLable"
                            [options]="waterLevelOptions" [chartType]="waterLevelType" [colors]="waterLevelColors"
                            (chartHover)="chartHovered($event)" data-toggle="modal" data-target="#devicePopupModal"
                            (chartClick)="chartClicked($event,'water_lavel')">
                        </canvas>
                    </div>
                    <div class="col-lg-6">
                        <div class="table-responsive pt-1">
                            <table class="table align-items-center">
                                <tbody>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #191970"></i>Empty Tank</td>
                                        <td>{{waterLavelEmpty}}</td>
                                    </tr>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #00BFFF"></i>Half Tank
                                        </td>
                                        <td>{{waterLavelHalf}}</td>
                                    </tr>
                                    <tr>
                                        <td><i class="fa fa-circle mr-2" style="color: #008080"></i>Full Tank
                                        </td>
                                        <td>{{waterLavelFull}}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>



<div class="row">
    <div class="col-lg-6">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title"> <i class="fa fa-users  p-2" style="font-size: 20px;"></i>Hourly People
                    Count </h5>
                <div>
                    <canvas baseChart [data]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
                        [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType">
                    </canvas>

                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-6">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title"><i class="fa fa-users p-2" style="font-size: 20px;"></i> Day-Wise People
                    Count</h5>
                <div>
                    <canvas baseChart [data]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
                        [colors]="barChartColors" [legend]="barChartLegend" [chartType]="barChartType">
                    </canvas>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="row card-body">
                <div class="col-md-5">
                    <h3 class="card-title"><i class="fa fa-users p-2" style="font-size: 20px;"></i><strong>Toilet  People Count</strong> </h3>
                </div>
                <div class="col-md-7">
                    <div class="form-group">
                        <label for="device_id">Toilet</label>
                        <ng-select [items]="deviceDataArr" bindLabel="deviceLabel" bindValue="id"
                            placeholder="Select Toilet" appendTo="body" name="device_id" id="device_id"
                            (change)="getHourlyDataDevicewise($event.id)" [(ngModel)]="dashboardForm.device_id"
                            (clear)="onClearDeviceData()">
                        </ng-select>
                    </div>
                </div>

                <div class="row col-lg-12">
                    <canvas class="device_graph_section" baseChart [data]="deviceBarChartData" [labels]="deviceBarChartLabels"
                        [options]="deviceBarChartOptions" [colors]="deviceBarChartColors"
                        [legend]="deviceBarChartLegend" [chartType]="deviceBarChartType"
                        (chartClick)="chartClickedDevicewise($event)">
                    </canvas>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="devicePopupModal" tabindex="-1" role="dialog" aria-labelledby="devicePopupModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content" style="height: 620px; overflow: scroll;">
            <div class="modal-header">
                <h5 class="modal-title" id="devicePopupModalLabel">Toilet Information</h5>
                <button type="button" class="close close-icon" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body p-1">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card m-0">
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table table-bordered  table-hover">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Toilet ID</th>
                                                <th>MoHUA (GTL ID)</th>
                                                <th>Toilet Name</th>
                                                <th>Device ID</th>
                                                <th style="white-space: normal;">Address</th>
                                                <!-- <th *ngIf="isFeedback==true" style="width: 30px;">Persons</th> -->
                                                <th *ngIf="isFeedback==true">Total Persons</th>
                                                <th *ngIf="isWaterLavel==true">Water Level</th>
                                                <th *ngIf="isWaterLavel==false && isFeedback==false">Air Quality
                                                </th>
                                                <th *ngIf="isWaterLavel==false && isFeedback==true">Feedback
                                                </th>
                                                <th>Updated</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of rowData; let i = index">
                                                <td>{{i+1}}</td>
                                                <td style="white-space: normal;">{{data.toilet_no}}</td>
                                                <td style="white-space: normal;">{{data.google_toilet_id}}</td>
                                                <td style="white-space: normal;">{{data.toilet_name}}</td>
                                                <td>{{data.device_id}}</td>
                                                <td style="white-space: normal;">{{data.address}}</td>
                                                <!-- <td *ngIf="isFeedback==true">{{data.person_count}}</td> -->
                                                <td *ngIf="isFeedback==true">{{data.person_count}}</td>
                                                <td *ngIf="isWaterLavel==true">{{data.water_lavel}}</td>
                                                <td *ngIf="isWaterLavel==false && isFeedback==false">
                                                    {{data.air_quality_status}}</td>
                                                <!-- <td *ngIf="isFeedback==false">{{data.air_quality_index}}</td> -->
                                                <td *ngIf="isWaterLavel==false && isFeedback==true">
                                                    {{data.feedback}}
                                                </td>
                                                <td>{{data.log_date_time}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div> -->
        </div>
    </div>
</div>

<div class="modal fade" id="contactModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Contact Information</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" >
                <table class="table table-bordered table-striped" style="font-size:14px;">

                    <tr>
                        <td class="text-center track_table_idle"><b>HO</b></td>
                        <td class="text-center track_table_idle" ><b id="hoName"></b></td>
                    </tr>
                    <tr>
                        <td class="text-center track_table_idle"><b>CSI</b></td>
                        <td class="text-center track_table_idle"><b id="csiName"></b></td>
                    </tr>
                    <tr>
                        <td class="text-center track_table_idle"><b>Daroga</b></td>
                        <td class="text-center track_table_idle"><b id="darogaName"></b></td>
                    </tr>

                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>